import { MouseEventHandler, ReactNode } from 'react'
import { LogIn } from '@stratascratch/icons'
import Button from '../Button'

function generateUrlWithNext(url: string, location: string | undefined) {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  if (!location) return origin + url

  if (url === location) {
    return origin + url
  }

  const searchParams = new URLSearchParams()
  searchParams.set('next', origin + location + searchParams.toString())

  return `${url}?${searchParams.toString()}`
}

interface RenderProps {
  variant: string
  size: string
  onClick: MouseEventHandler<HTMLAnchorElement>
  children: ReactNode
}

export interface Props {
  renderLink: (props: RenderProps) => React.ReactNode
  closeMenu: () => void
  pathname: string | undefined
}

function LoggedOutAuthMenu({ renderLink, closeMenu, pathname }: Props) {
  const loginUrl = generateUrlWithNext('/login', pathname)
  const registrationUrl = generateUrlWithNext('/registration', pathname)

  return (
    <>
      <Button
        as="link"
        variant="outline"
        size="small"
        linkEl={(props) =>
          renderLink({
            ...props,
            href: loginUrl,
            onClick: closeMenu,
            children: (
              <>
                <LogIn />
                Login
              </>
            ),
          })
        }
      />
      <Button
        as="link"
        variant="primary"
        size="small"
        linkEl={(props) =>
          renderLink({
            ...props,
            href: registrationUrl,
            onClick: closeMenu,
            children: 'Register',
          })
        }
      />
    </>
  )
}

export default LoggedOutAuthMenu
